// components/Footer.js
import React from 'react';
import { View, Text, TouchableOpacity, Linking } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { useRoute } from '@react-navigation/native';
import styles from './styles/styles';  // Your existing style import

const Footer = ({ navigation }) => {
  const route = useRoute();
  const currentRoute = route.name;

  const links = [
    { name: 'About Us', route: 'AboutUs' },
    { name: 'Success Stories', route: 'SuccessStories' },
    { name: 'For Business', route: 'Service' },
    { name: 'Culture', route: 'Culture' },
    { name: 'Careers', route: 'Career' },
    { name: 'Contact', route: 'Contact' },
    { name: 'Privacy Policy', route: 'Privacy' },
  ];

  return (
    <View style={styles.footer}>
      <View style={styles.footerLinks}>
        {links.map((link) => (
          <View key={link.route} style={styles.footerTextWrapper}>
            <TouchableOpacity onPress={() => navigation.navigate(link.route)}>
              <Text style={[
                styles.footerText,
                currentRoute === link.route && { opacity: 0.4 } // dim active link
              ]}>
                {link.name}
              </Text>
            </TouchableOpacity>
          </View>
        ))}
      </View>

      <View style={{ height: 20 }} />

      <View style={styles.socialIcons}>
        <Text style={styles.footerText}>IntegrationX © 2025</Text>
        <TouchableOpacity onPress={() => Linking.openURL('https://x.com/integrationx_ai')}>
          <Text style={[styles.icon, { fontSize: 20, color: '#ccc' }]}>𝕏</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => Linking.openURL('https://linkedin.com/company/integrationx')}>
          <Feather name="linkedin" size={20} color="#ccc" style={styles.icon} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => Linking.openURL('mailto:info@integrationx.ai')}>
          <Feather name="mail" size={20} color="#ccc" style={styles.icon} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default Footer;
